export interface LabelValueProps {
  label: string;
  value: string | undefined;
}

const LabelValue: React.FC<LabelValueProps> = ({ label, value }) => {
  return (
    <div className={"label-value"}>
      <p className={"label"}>
        {label}
        {label && value && ": "}
      </p>
      <b className={"value"}>{value}</b>
    </div>
  );
};
export default LabelValue;
